import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Content } from "./Content";

interface CommunityHeaderProp {
  className?: string;
}

export const CommunityHeader = ({ className }: CommunityHeaderProp) => {
  const { currentCommunity } = usePaywallCheckoutContext();

  return (
    <div
      className={classNames(
        "flex flex-row justify-center py-5 lg:py-10",
        className,
      )}
    >
      <Content currentCommunity={currentCommunity} />
    </div>
  );
};
